import React from 'react';
import Link from 'gatsby-link';

import '../../sass/components/_hamburger.scss';

const Hamburger = (props) => (
  <button onClick={props.handleClick} className={`hamburger hamburger--spin ${props.isMenuVisible ? ' is-active' : ''}`} type="button">
    <span className="hamburger-box">
      <span className="hamburger-inner"></span>
    </span>
  </button>
);

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/Hamburger.js